// Dokumenten-Flags einmal pro Session laden, egal wie viele Komponenten fragen.
let documentStatusPromise = null

export default {
  resetState ({ commit }) {
    commit('resetUser')
  },
  insertUser ({ state, commit }, value) {
    commit('insertUser', value)
  },
  updateUser ({ state, commit }, value) {
    commit('updateUser', value)
  },
  setTokenWithoutBearer ({ commit }, value) {
    commit('setTokenWithoutBearer', value)
  },
  deleteDocument ({ commit }, udid) {
    commit('deleteDocument', udid)
  },
  deleteUpload ({ commit }, udid) {
    commit('deleteUpload', udid)
  },
  updateIban ({ commit }, value) {
    commit('updateIban', value)
  },
  async reloadUser ({ commit }) {
    const user = await this.$api.user.status()
    commit('updateUser', user)
  },
  setDocuments ({ commit }, value) {
    commit('setDocuments', value)
  },
  updateAllowWebid ({ commit }, value) {
    commit('updateAllowWebid', value)
  },
  changeTopInsurance ({ commit }, value) {
    commit('changeTopInsurance', value)
  },
  changeDirectInsurance ({ commit }, value) {
    commit('changeDirectInsurance', value)
  },
  changePath ({ commit }, value) {
    commit('changePath', value)
  },
  changeSanierungsStatus ({ commit }, value) {
    commit('changeSanierungsStatus', value)
  },
  // Laedt die S3-Dokumenten-Flags nach. /customer/status liefert sie nur noch
  // als null ("noch nicht geprueft").
  fetchDocumentStatus ({ commit, state }) {
    if (state.documentStatus.resolved) {
      return Promise.resolve(state.documentStatus)
    }
    if (!documentStatusPromise) {
      documentStatusPromise = this.$api.user.documentStatus()
        .then((data) => {
          commit('setDocumentStatus', data)
          return state.documentStatus
        })
        .catch((error) => {
          // Nicht als "geprueft" markieren, damit ein spaeterer Aufruf erneut versucht.
          documentStatusPromise = null
          throw error
        })
    }
    return documentStatusPromise
  },
  // Krankenkassen-Teil vorerst deaktiviert: keine Abfrage ans Backend, wir
  // markieren den Status direkt als geprueft (nicht anzeigen, nicht angemeldet).
  // Zum Reaktivieren die Abfrage unten wieder einkommentieren.
  fetchKrankenkasse ({ commit, state }) {
    if (!state.krankenkasse.resolved) {
      commit('setKrankenkasse', { show: false, subscribed: false, resolved: true })
    }
    return Promise.resolve(state.krankenkasse)
    // let krankenkassePromise = null (Modulvariable wieder anlegen)
    // if (!krankenkassePromise) {
    //   krankenkassePromise = Promise.all([
    //     this.$api.user.krankenkasseShow().then(data => !!data?.show).catch(() => false),
    //     this.$api.user.krankenkasseStatus().then(data => !!data?.subscribed).catch(() => false)
    //   ]).then(([show, subscribed]) => {
    //     commit('setKrankenkasse', { show, subscribed, resolved: true })
    //     return { show, subscribed, resolved: true }
    //   })
    // }
    // return krankenkassePromise
  },
  subscribeKrankenkasse ({ commit }) {
    return this.$api.user.krankenkasseSubscribe()
      .then(() => commit('setKrankenkasseSubscribed', true))
  },
  unsubscribeKrankenkasse ({ commit }) {
    return this.$api.user.krankenkasseUnsubscribe()
      .then(() => commit('setKrankenkasseSubscribed', false))
  }
}
